import React, { useMemo } from 'react';
import { Card } from '../components/ui';
import Calendar from '../components/Calendar/Calendar';
import { usePostModalStore } from '../store/usePostModalStore';
import { Loader2 } from 'lucide-react';
import { useGetPosts } from '../queries/post';
import useErrorModalStore from '../store/useErrorModalStore';
import { getErrorModalMessage } from '../utils/errorMessages';
import { usePostsPoll } from '../queries/onboardingPolls';

const TimeSlotsPage = () => {
  const { openModal } = usePostModalStore();
  const { openErrorModal } = useErrorModalStore();

  const handlePostsError = (error) => {
    if (error?.status >= 500) {
      return openErrorModal(getErrorModalMessage('server_error'), 'server_error');
    }
    openErrorModal(getErrorModalMessage('calendar_posts_error'), 'calendar_posts_error');
  };

  const { data: posts = [], isLoading } = useGetPosts(true, null, handlePostsError);
  const hasDraftPosts = useMemo(() => posts.some((post) => post.status === 'draft'), [posts]);
  const shouldPollPosts = useMemo(() => !posts.length || hasDraftPosts, [posts, hasDraftPosts]);

  // eslint-disable-next-line
  const postsPoll = usePostsPoll(shouldPollPosts, 'dashboard');

  const handleEventClick = (clickInfo) => {
    const post = clickInfo.event.extendedProps.post;
    if (post.status === 'draft') return;
    openModal(post);
  };

  if (isLoading) {
    return (
      <div className='space-y-6'>
        <div className='flex items-center justify-between'>
          <h1 className='text-2xl font-bold' style={{ color: 'var(--text-primary)' }}>
            Content Calendar
          </h1>
        </div>
        <Card>
          <Card.Body>
            <div className='flex items-center justify-center py-20'>
              <Loader2 className='w-10 h-10 animate-spin' style={{ color: 'var(--brand)' }} />
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }

  return (
    <div className='h-[calc(100vh-100px)] flex flex-col gap-4'>
      <Calendar posts={posts} onEventClick={handleEventClick} />
    </div>
  );
};

export default TimeSlotsPage;
